export const subtaskResourceType = "subtask" as const;
export const completeSubtaskResourceType = "complete_subtask" as const;
export const rateSubtaskResourceType = "rate_subtask" as const;

export const getSubtaskResourcePath = (
  userGroupId: string,
  subtaskId: string
) => {
  return `/user_groups/${userGroupId}/subtasks/${subtaskId}`;
};

export const completeSubtaskResourcePath = (
  userGroupId: string,
  subtaskId: string
) => {
  return `/user_groups/${userGroupId}/subtasks/${subtaskId}/complete`;
};

export const rateSubtaskResourcePath = (
  companyId: string,
  subtaskId: string
) => {
  return `/companies/${companyId}/subtasks/${subtaskId}/rate`;
};
